import React, { Component } from 'react';
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { ClipLoader } from 'react-spinners';
import { connect } from 'react-redux';
import api from '../Api';
import { Modal, Button } from "reactstrap";
import NotificationAlert from "react-notification-alert";

class Comment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      load: false,
      open: false,
      openDialogRemove: false,
      comments: [],
      currentComment: null,
      commentToDelete: null,
      user: {
        id: this.props.user?.id || window.app.state.user.id,
        username: this.props.user?.username || window.app.state.user.username
      },
      classroom: Number(props.classroom),
      unit: props.unit ? Number(props.unit) : null,
      lesson: props.lesson ? Number(props.lesson) : null,
      permissions: Array.isArray(props.permission) ? props.permission : [],
      users: [],
      showUsersList: false,
      filteredUsers: [],
      mentionedUsers: [],
      mentionQuery: '',
      newComment: {
        user: Number(props.user?.id || window.app.state.user.id),
        username: props.user?.username || window.app.state.user.username,
        classroom: Number(props.classroom),
        unit: props.unit ? Number(props.unit) : null,
        lesson: props.lesson ? Number(props.lesson) : null,
        comment: '',
        comment_edit: null,
        resp_comment: null,
        isPrivate: false,
        mentionedUsers: []
      },
      sortOrder: 'desc',
      filterType: 'all',
      isInstructor: false,
      commentsLockedCached: false
    };
    
    // chamada para inicializar permissões
    this.updatePermissionsAndInstructor(this.props);
    window.comment = this;
    this.getClassroomOptions = this.getClassroomOptions.bind(this);
    this.isCommentsLocked = this.isCommentsLocked.bind(this);
  }

  getClassroomOptions(raw = this.props.classroom_option){
    if(!raw) return [];
    if(Array.isArray(raw)) return raw;
    if(typeof raw === 'object') return Object.values(raw);
    return [];
  }

  //define/atualiza permissões e flag de instrutor
  updatePermissionsAndInstructor = (props) => {
    const permissions = Array.isArray(props.permission) ? props.permission : [];
    const lowerNames = permissions.map(p =>
      (typeof p === 'string') ? p.toLowerCase()
        : (p && (p.name || p.role)) ? String(p.name || p.role).toLowerCase()
        : ''
    );

    const instructorKeywords = ['instructor','instrutor','professor','teacher','admin','owner','moderator'];
    const isInstructor = lowerNames.some(name =>
      instructorKeywords.includes(name) ||
      (name.includes('prof') || name.includes('instrutor') || name.includes('teacher'))
    );

    // Atualiza somente se algo mudou
    this.setState(prev => {
      if (prev.isInstructor !== isInstructor || prev.permissions !== permissions) {
        return { permissions, isInstructor };
      }
      return null;
    });
  };

  // DETECÇÃO MELHORADA
  isCommentsLocked = () => {
    const opts = this.getClassroomOptions();
    if(!opts || !opts.length) return false;
    try {
      return opts.some(o => {
        if(!o) return false;
        // Se for string simples
        if(typeof o === 'string'){
          const s = o.toLowerCase();
            return ['lock_comments','comments_locked'].includes(s) ||
                   (s.includes('lock') && s.includes('comment'));
        }
        // verifica qualquer valor textual
        if(typeof o === 'object'){
          const values = Object.values(o).map(v => (v!==null && v!==undefined) ? String(v).toLowerCase() : '');
          return values.some(v => 
            ['lock_comments','comments_locked','1'].includes(v) && values.some(v2 => v2.includes('lock') || v2.includes('comment')) ||
            (v.includes('lock') && v.includes('comment'))
          );
        }
        return false;
      });
    } catch(e){
      console.warn('Erro avaliando lock_comments', e);
      return false;
    }
  };

  refreshLockStatus = () => {
    const locked = this.isCommentsLocked();
    if (locked !== this.state.commentsLockedCached) {
      this.setState({ commentsLockedCached: locked });
    }
  };

  componentDidMount() {
    this.updatePermissionsAndInstructor(this.props);
    
    // Listener pra capturar o resize da tela
    window.addEventListener('resize', this.handleWindowResize);
    this.refreshLockStatus();
  }

  componentWillUnmount() {
    // Remove o listener quando o componente for desmontado
    window.removeEventListener('resize', this.handleWindowResize);
  }

  handleWindowResize = () => {
    // Força uma nova renderização quando o tamanho da janela mudar
    this.forceUpdate();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.permission !== this.props.permission ||
        prevProps.user !== this.props.user) {
      this.updatePermissionsAndInstructor(this.props);
      if (prevProps.user !== this.props.user && this.props.user) {
        this.setState({
          user: {
            id: this.props.user.id,
            username: this.props.user.username
          },
          newComment: {
            ...this.state.newComment,
            user: Number(this.props.user.id),
            username: this.props.user.username
          }
        });
      }
    }
    if (prevProps.classroom_option !== this.props.classroom_option) {
      this.refreshLockStatus();
    }
  }

  buildQuery = (params) => {
    let query = "";
    
    // Sempre incluir classroom
    query += `?classroom=${params.classroom}`;
    
    // Se tiver unit, adiciona ao query
    if (params.unit) {
      query += `&unit=${params.unit}`;
      
      // Se tiver lesson, só adiciona se também tiver unit
      if (params.lesson) {
        query += `&lesson=${params.lesson}`;
      }
    }
    
    return query;
  }

  loadComments = () => {
    this.setState({ load: true });

    const queryParams = {
      classroom: this.state.classroom
    };

    if (this.state.unit) {
      queryParams.unit = this.state.unit;
      
      if (this.state.lesson) {
        queryParams.lesson = this.state.lesson;
      }
    }

    const query = this.buildQuery(queryParams);
    console.log("Query construída:", query);

    api.getAllUserComments(query)
      .then(response => {
        console.log("Comentários recebidos:", response.data);
        this.setState({
          comments: response.data,
          load: false,
          open: true
        });
      })
      .catch(error => {
        console.error('Erro ao carregar comentários:', error);
        this.setState({ 
          load: false,
          open: true
        });
      });
  };

  open = (obj) => {
    console.log('Dados recebidos no open:', obj); 
    console.log("Props recebidas:", this.props);
    console.log("Permissões brutas:", this.props.permission);
    console.log(window.app.state.user.id);
    console.log(this.state.user);


    const newState = {
      open: true,
      load: false,
      classroom: Number(obj.classroom),
      unit: obj.unit ? Number(obj.unit) : null,
      lesson: obj.unit && obj.lesson ? Number(obj.lesson) : null,
      newComment: {
        ...this.state.newComment,
        user: this.state.user.id,
        username: this.state.user.username,
        classroom: Number(obj.classroom),
        unit: obj.unit ? Number(obj.unit) : null,
        lesson: obj.unit && obj.lesson ? Number(obj.lesson) : null,
      }
    };

    this.setState(newState, () => {
      this.refreshLockStatus();
      this.loadComments();
    });
  };

  close = () => {
    this.setState({ 
      open: false
    });
  };

  formatCommentWithMentions = (text) => {
    if (!text) return '';
    
    // Divide o texto em partes usando regex para identificar menções (@palavra)
    const parts = text.split(/(@\w+)/g);
    
    return parts.map((part, index) => {
      // Se a parte começa com @, é uma menção
      if (part.startsWith('@')) {
        return (
          <span key={index} style={{ color: '#007bff' }}>
            {part}
          </span>
        );
      }
      return part;
    });
  };

  montComments = (comment, sum, isResp = false) => {
    const { isInstructor } = this.state;
    const isOwner = Number(comment.user) === Number(this.state.user.id);
    const isEditing = this.state.currentComment?.id === comment.id;
    const isReplying = this.state.currentComment?.resp_comment === comment.id;
    const isHidden = Number(comment.isHidden) === 1;
    const MAX_INDENT = 3;
    const indentLevel = Math.min(sum, MAX_INDENT);
    const isMobile = window.innerWidth < 576;

    // Calcular recuo responsivo
    const getResponsiveIndent = () => {
      if (isMobile) {
        return `${indentLevel * 10}px`; // Recuo menor em telas pequenas
      } else if (window.innerWidth < 768) {
        return `${indentLevel * 25}px`;
      } else {
        return `${indentLevel * 50}px`;
      }
    };

    return(
      <>
        <div 
          key={comment.id} 
          id={`comment-${comment.id}`}
          data-comment-id={comment.id}
          className={`media mb-4 ${isHidden ? 'comment-hidden' : ''} ${isMobile ? 'media-mobile' : ''}`}
          style={{
            marginLeft: getResponsiveIndent(),
            transition: 'all 0.3s ease',
            padding: isMobile ? '8px' : '15px',
            border: isHidden ? '1px dashed #5e72e4' : 'none', 
            borderRadius: '8px',
            backgroundColor: isHidden ? 'rgba(94, 114, 228, 0.1)' : 'transparent',
            position: 'relative',
            width: `calc(100% - ${getResponsiveIndent()})`,
            maxWidth: isMobile ? '100%' : '450px',
            wordBreak: 'break-word',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row'
          }}
        >
          <div className={`avatar-container ${isMobile ? 'mb-2' : ''}`}>
            <img 
              src={comment.photo ? comment.photo : `https://ui-avatars.com/api/?name=${comment.username || 'User'}&background=random`}
              className={`rounded-circle ${isMobile ? '' : 'mr-3'}`}
              alt="avatar"
              style={{ 
                width: isMobile ? '32px' : '40px', 
                height: isMobile ? '32px' : '40px',
                opacity: isHidden ? '0.7' : '1'
              }}
            />
          </div>
          <div className="media-body w-100">
            <div className={`user-header d-flex ${isMobile ? 'flex-column align-items-start' : 'justify-content-between align-items-center'}`}>
              <h6 className="mt-0 mb-1">{comment.username}</h6>
              <small className="text-muted">
                {new Date(comment.createDate).toLocaleString(undefined, 
                  isMobile ? {month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'} : undefined)}
              </small>
            </div>
            
            {isEditing ? (
              <div className="form-group mb-2">
                <textarea
                  className="form-control"
                  name="comment"
                  value={this.state.currentComment.comment}
                  onChange={this.handleChange}
                  rows="3"
                />
                <div className="mt-2">
                  <button 
                    className="btn btn-sm btn-primary mr-2"
                    onClick={this.handleSubmit}
                  >
                    Salvar
                  </button>
                  <button 
                    className="btn btn-sm btn-secondary"
                    onClick={() => this.setState({ currentComment: null })}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            ) : (
              <>
                <p className="mb-1">
                  {this.formatCommentWithMentions(comment.comment)}
                </p>
                {comment.comment_edit && (
                  <small className="text-muted d-block mb-2">
                    <em>Editado: {comment.comment_edit}</em>
                  </small>
                )}
              </>
            )}

            {!isEditing && (
              <div className="comment-actions">
              
                {isOwner && (
                  <button 
                    className="btn btn-sm btn-link mr-2 p-0"
                    onClick={() => this.handleEdit(comment)}
                  >
                    <i className="fas fa-edit mr-1"></i>Editar
                  </button>
                )}
                <button 
                  className="btn btn-sm btn-link mr-2 p-0"
                  onClick={() => this.handleReply(comment)}
                >
                  <i className="fas fa-reply mr-1"></i>Responder
                </button>
          
                {isOwner && (
                  <button 
                    className="btn btn-sm btn-link text-danger p-0"
                    onClick={() => this.handleDelete(comment.id)}
                  >
                    <i className="fas fa-trash-alt mr-1"></i>Excluir
                  </button>
                )}
                
                {isInstructor && (
                  <button
                    className={`btn btn-sm ${comment.isHidden ? 'btn-warning' : 'btn-outline-warning'} ml-2`}
                    onClick={() => this.toggleCommentVisibility(comment.id)}
                    title={comment.isHidden ? "Mostrar comentário" : "Ocultar comentário"}
                  >
                    <i className={`fas fa-${comment.isHidden ? 'eye' : 'eye-slash'}`}></i>
                    {Boolean(comment.isHidden) && (
                      <span className="ml-2" style={{ 
                          color: '#FFFFFF',  
                          fontSize: '0.75rem',
                          fontWeight: '500',
                          opacity: '0.8'
                      }}>
                          OCULTADO
                      </span>
                    )}
                  </button>
                )}
              </div>
            )}

            {isReplying && (
              <div className="form-group mb-2 mt-3" style={{marginLeft: '20px'}}>
                <textarea
                  className="form-control"
                  name="comment"
                  value={this.state.currentComment.comment}
                  onChange={this.handleChange}
                  rows="3"
                  placeholder="Digite sua resposta..."
                />
                <div className="mt-2">
                  <button 
                    className="btn btn-sm btn-primary mr-2"
                    onClick={this.handleSubmit}
                  >
                    {this.state.currentComment.resp_comment ? 'Responder' : 'Salvar'}
                  </button>
                  <button 
                    className="btn btn-sm btn-secondary"
                    onClick={() => this.setState({ currentComment: null })}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {isResp == false && 
          <React.Fragment>
            {comment.resps.map(resp => {
              return(
                <>
                  {this.montComments(resp, sum + 1)}
                </>
              )
            })}
          </React.Fragment>
        }

        {isInstructor && isHidden && (
          <div 
            className="mt-1 mb-3"
            style={{
              marginLeft: `calc(${getResponsiveIndent()} + ${window.innerWidth < 576 ? '20px' : '50px'})`,
              color: '#5e72e4',
              fontSize: '0.85rem',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <i className="fas fa-info-circle"></i>
            {window.innerWidth < 576 ? 
              <span>Comentário oculto</span> : 
              <span>Este comentário e suas respostas estão ocultos para os alunos</span>}
          </div>
        )}
      </>
    )
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    
    // Se for o campo de comentário, use handleCommentChange
    if (name === 'comment') {
      this.handleCommentChange(e);
      return;
    }

    // Para outros campos, mantenha a lógica original
    if (this.state.currentComment) {
      this.setState(prevState => ({
        currentComment: {
          ...prevState.currentComment,
          [name]: value
        }
      }));
    } else {
      this.setState(prevState => ({
        newComment: {
          ...prevState.newComment,
          [name]: value
        }
      }));
    }
  };

  handleCommentChange = (e) => {
    const { value } = e.target;
    const lastChar = value[value.length - 1];
    
    // Verifica se existem menções no texto atual
    const mentions = value.match(/@\w+/g) || [];
    const mentionedUsernames = mentions.map(mention => mention.substring(1)); // Remove o @ do início
    
    // Filtra mentionedUsers para manter apenas os que ainda estão mencionados no texto
    const updatedMentionedUsers = this.state.newComment.mentionedUsers.filter(userId => {
        const user = this.state.users.find(u => u.id === userId);
        return user && mentionedUsernames.includes(user.username);
    });

    if (this.state.currentComment) {
        this.setState(prevState => ({
            currentComment: {
                ...prevState.currentComment,
                comment: value,
                mentionedUsers: updatedMentionedUsers
            }
        }));
    } else {
        this.setState(prevState => ({
            newComment: {
                ...prevState.newComment,
                comment: value,
                mentionedUsers: updatedMentionedUsers,
                isPrivate: updatedMentionedUsers.length > 0
            }
        }));
    }

    // Lógica para mostrar a lista de usuários
    if (lastChar === '@') {
        this.setState({ 
            showUsersList: true,
            mentionQuery: ''
        });
        this.loadClassroomUsers();
    } else if (this.state.showUsersList) {
        const mentionQuery = value.split('@').pop();
        this.setState({ 
            mentionQuery,
            filteredUsers: this.state.users.filter(user => 
                user.username.toLowerCase().includes(mentionQuery.toLowerCase())
            )
        });
    }
  };

  showNotification = (type, message) => {
    let options = {
      place: "tr",
      message: (
        <div>
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {type === 'success' ? 'Sucesso!' : 'Erro!'}
            </span>
            <span data-notify="message">{message}</span>
          </div>
        </div>
      ),
      type: type,
      icon: type === 'success' ? "ni ni-check-bold" : "ni ni-fat-remove",
      autoDismiss: 7
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  handleSubmit = () => {
    // garante decisão pelo cache (UI já deve esconder textarea)
    if (this.state.commentsLockedCached && !this.state.isInstructor) {
      this.showNotification('danger','Comentários bloqueados.');
      return;
    }
    const commentsLocked = this.isCommentsLocked();
    if (commentsLocked && !this.state.isInstructor) {
      // sincroniza caso ainda não estivesse em cache
      this.setState({ commentsLockedCached: true });
      this.showNotification('danger','Comentários bloqueados.');
      return;
    }
    // ...restante do código original de envio...
    const { currentComment, newComment } = this.state;
    const commentData = currentComment || newComment;
    const isEditing = currentComment?.id !== undefined;
    const validData = {
      ...commentData,
      user: Number(this.state.user.id),
      username: this.state.user.username,
      classroom: Number(this.state.classroom) || null,
      unit: Number(this.state.unit) || null,
      lesson: Number(this.state.lesson) || null
    };
    const onSuccess = (msg) => {
      this.showNotification('success', msg);
      this.setState({ currentComment: null, newComment: { ...newComment, comment: '' }});
      this.open({ classroom:this.state.classroom, unit:this.state.unit, lesson:this.state.lesson });
    };
    const onError = (errMsg, err) => {
      // Se API retornou bloqueio (ex: 403 / 423 / mensagem)
      const status = err?.response?.status;
      const serverMsg = (err?.response?.data && JSON.stringify(err.response.data).toLowerCase()) || '';
      const detectedLock = status === 403 || status === 423 || serverMsg.includes('lock') || serverMsg.includes('bloque');
      if (detectedLock) {
        this.setState({ commentsLockedCached: true });
        this.showNotification('danger','Comentários bloqueados.');
      } else {
        this.showNotification('danger', errMsg);
      }
    };
    if (isEditing) {
      api.putUserComment(currentComment.id, validData)
        .then(() => onSuccess('Comentário editado com sucesso!'))
        .catch(err => onError('Erro ao editar comentário', err));
    } else {
      api.postUserComment(validData)
        .then(() => onSuccess('Comentário publicado com sucesso!'))
        .catch(err => onError('Erro ao publicar comentário', err));
    }
  };

  handleDelete = (commentId) => {
    this.setState({
      openDialogRemove: true,
      commentToDelete: commentId
    });
  };

  remove = async () => {
    // Localiza o comentário-alvo na árvore
    const findCommentInTree = (comments, targetId) => {
      for (let c of comments) {
        if (c.id === targetId) return c;
        if (c.resps && c.resps.length > 0) {
          const found = findCommentInTree(c.resps, targetId);
          if (found) return found;
        }
      }
      return null;
    };

    const targetComment = findCommentInTree(this.state.comments, this.state.commentToDelete);
    if (!targetComment) {
      this.setState({ openDialogRemove: false, commentToDelete: null });
      return;
    }

    // Se comentário-tem-filhos => apenas oculta senão, deleta normalmente
    if (targetComment.resps && targetComment.resps.length > 0) {
      try {
        await this.toggleCommentVisibility(targetComment.id);
        this.showNotification('success', 'Seu comentários foi ocultado, para manter as respostas.');
      } catch (err) {
        console.error('Erro ao ocultar comentário:', err);
        this.showNotification('danger', 'Não foi possível ocultar o comentário.');
      }
      this.setState({ openDialogRemove: false, commentToDelete: null });
    } else {
      api.deleteUserComment(this.state.commentToDelete)
        .then(() => {
          this.showNotification('success', 'Comentário removido com sucesso!');
          this.setState({
            openDialogRemove: false,
            commentToDelete: null
          });
          this.open({
            classroom: this.state.classroom,
            unit: this.state.unit,
            lesson: this.state.lesson
          });
        })
        .catch(error => {
          console.error('Erro ao deletar comentário:', error);
          this.showNotification('danger', 'Erro ao remover comentário');
          this.setState({
            openDialogRemove: false,
            commentToDelete: null
          });
        });
    }
  };

  handleReply = (comment) => {
    this.setState({
      currentComment: {
        user: this.state.user,
        classroom: this.state.classroom,
        unit: this.state.unit,
        lesson: this.state.lesson,
        comment: '',
        resp_comment: comment.id
      }
    });
  };

  handleEdit = (comment) => {
    this.setState({
      currentComment: {
        id: comment.id,
        user: this.state.user,
        classroom: this.state.classroom,
        unit: this.state.unit,
        lesson: this.state.lesson,
        comment: comment.comment,
        comment_edit: comment.comment
      }
    });
  };

  loadClassroomUsers = () => {
    api.searchUserClassRoom(this.state.classroom)
      .then(response => {
        this.setState({ 
          users: response.data,
          filteredUsers: response.data
        });
      })
      .catch(error => {
        console.error('Erro ao carregar usuários:', error);
      });
  };

  handleMentionSelect = (user) => {
    const { newComment } = this.state;
    const commentParts = newComment.comment.split('@');
    const updatedComment = commentParts.slice(0, -1).join('@') + `@${user.username} `;
    
    this.setState(prevState => ({
      newComment: {
        ...prevState.newComment,
        comment: updatedComment,
        isPrivate: true,
        mentionedUsers: [...prevState.newComment.mentionedUsers, user.id]
      },
      showUsersList: false
    }));
  };

  sortComments = (comments) => {
    return [...comments].sort((a, b) => {
      if (this.state.sortOrder === 'desc') {
        return new Date(b.createDate) - new Date(a.createDate);
      }
      return new Date(a.createDate) - new Date(b.createDate);
    });
  };

  filterComments = (comments) => {
    const { filterType, isInstructor } = this.state;
    console.log("Filtrando comentários:", { filterType, isInstructor, totalComments: comments.length });


    let filteredComments = comments;
    if (!isInstructor) {
        filteredComments = comments.filter(comment => !comment.isHidden);
        console.log("Comentários após filtro de visibilidade:", filteredComments.length);
    }

    switch (filterType) {
        case 'mine':
            return filteredComments.filter(comment => 
                Number(comment.user) === Number(this.state.user.id)
            );
        case 'private':
            return filteredComments.filter(comment => 
                comment.isPrivate === true
            );
        case 'hidden':
            return isInstructor ? comments.filter(comment => comment.isHidden) : [];
        default:
            return filteredComments;
    }
  };

  toggleCommentVisibility = async (commentId) => {
    try {
        const findCommentInTree = (comments, targetId) => {
            for (let comment of comments) {
                if (comment.id === targetId) {
                    return comment;
                }
                if (comment.resps && comment.resps.length > 0) {
                    const found = findCommentInTree(comment.resps, targetId);
                    if (found) return found;
                }
            }
            return null;
        };

        const comment = findCommentInTree(this.state.comments, commentId);
        console.log("Comentário antes da atualização:", comment);
        
        // Função recursiva para atualizar comentários e suas respostas
        const updateCommentAndReplies = async (commentData, newHiddenState) => {
            // Atualiza o comentário atual
            const updateData = {
                id: commentData.id,
                user: commentData.user,
                classroom: commentData.classroom,
                unit: commentData.unit,
                lesson: commentData.lesson,
                comment: commentData.comment,
                isHidden: newHiddenState,
                resp_comment: commentData.resp_comment
            };
            
            console.log(`Atualizando comentário ${commentData.id} para isHidden: ${newHiddenState}`);
            await api.putUserComment(commentData.id, updateData);
            
            // Se o comentário tem respostas, atualiza cada uma delas recursivamente
            if (commentData.resps && commentData.resps.length > 0) {
                for (const reply of commentData.resps) {
                    await updateCommentAndReplies(reply, newHiddenState);
                }
            }
        };

        // Inicia o processo de atualização com o novo estado
        const newHiddenState = !comment.isHidden;
        await updateCommentAndReplies(comment, newHiddenState);
        
        // Recarrega os comentários para atualizar a visualização
        await this.loadComments();
        
        // Mostra notificação de sucesso
        this.showNotification(
            'success', 
            `Comentário ${newHiddenState ? 'ocultado' : 'mostrado'} com sucesso!`
        );
        
    } catch (error) {
        console.error('Erro ao atualizar visibilidade:', error.response?.data || error);
        this.showNotification('danger', 'Erro ao atualizar visibilidade do comentário');
    }
  };

  render() {
    const {
      currentComment,
      newComment,
      load,
      open,
      comments,
      openDialogRemove,
      showUsersList,
      filteredUsers,
      isInstructor
    } = this.state;


    const rawOpts = this.props.classroom_option;
    const optsArray = Array.isArray(rawOpts)
      ? rawOpts
      : rawOpts && typeof rawOpts === 'object'
        ? Object.values(rawOpts)
        : [];

    const commentsLockedRuntime = this.isCommentsLocked();
    const commentsLocked = this.state.commentsLockedCached || commentsLockedRuntime;
    const lockActiveForUser = commentsLocked && !isInstructor;

    // Determina a largura do painel com base no tamanho da tela
    const getPaneWidth = () => {
      if (window.innerWidth < 576) {
        return '100%';
      } else if (window.innerWidth < 992) {
        return '85%';
      } else {
        return '700px';
      }
    };

    const renderText = (text) => {
        return text.split(' ').map((word, index) => {
            if (word.startsWith('@')) {
                return <span key={index}><span className="text-primary">{word}</span> </span>;
            }
            return <span key={index}>{word} </span>;
        });
    };

    return (
      <>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>

        <SlidingPane
          className="comment-sliding-pane"
          overlayClassName="comment-overlay"
          isOpen={open}
          title="Comentários"
          subtitle="Discussão da unidade"
          onRequestClose={this.close}
          width={getPaneWidth()}
          zIndex={1051}
        >
          <div className="p-3">
            {load ? (
              <div className="d-flex justify-content-center align-items-center" style={{height:'100%'}}>
                <ClipLoader color="#000" size={30} />
              </div>
            ) : (
              <>
                <div className={window.innerWidth < 768 ? "d-flex flex-column" : "d-flex justify-content-between align-items-center mb-4"}>
                  <div className="btn-group mb-2">
                    <button
                      className={`btn btn-sm ${this.state.filterType === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => this.setState({ filterType: 'all' })}
                    >
                      Todos
                    </button>
                    <button
                      className={`btn btn-sm ${this.state.filterType === 'mine' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => this.setState({ filterType: 'mine' })}
                    >
                      Meus Comentários
                    </button>
                    <button
                      className={`btn btn-sm ${this.state.filterType === 'private' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => this.setState({ filterType: 'private' })}
                    >
                      Privados
                    </button>
                    {isInstructor && (
                      <button
                        className={`btn btn-sm ${this.state.filterType === 'hidden' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => this.setState({ filterType: 'hidden' })}
                      >
                        <i className="fas fa-eye-slash mr-1"></i>
                        Ocultos
                      </button>
                    )}
                  </div>
                  
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => this.setState(prev => ({
                      sortOrder: prev.sortOrder === 'desc' ? 'asc' : 'desc'
                    }))}
                  >
                    <i className={`fas fa-sort-${this.state.sortOrder === 'desc' ? 'down' : 'up'}`}></i>
                    {' '}
                    {window.innerWidth < 576 ? (this.state.sortOrder === 'desc' ? 'Recentes' : 'Antigos') : 
                     (this.state.sortOrder === 'desc' ? 'Mais recentes' : 'Mais antigos')}
                  </button>
                </div>

                <div className="mb-4">
                  {lockActiveForUser && (
                    <div className="comments-locked-box text-center mb-3">
                      <div className="icon-wrap">
                        <i className="fas fa-eye-slash"></i>
                      </div>
                      <h5 className="mt-3 mb-1">Comentários bloqueados</h5>
                      <p className="text-muted mb-2" style={{fontSize:'0.85rem'}}>
                        O instrutor desativou temporariamente novos comentários.
                      </p>
                      <small className="text-muted d-block">
                        Você ainda pode ler os já existentes.
                      </small>
                    </div>
                  )}

                  {!lockActiveForUser && (
                    <div className="form-group position-relative new-comment-wrapper">
                      <label className="mb-1">Novo comentário:</label>
                      <textarea
                        className="form-control"
                        name="comment"
                        value={newComment.comment}
                        onChange={this.handleCommentChange}
                        rows="4"
                        placeholder="Digite seu comentário... Use @ para mencionar usuários"
                      />
                      {showUsersList && (
                        <div className="mention-list position-absolute bg-white shadow p-2" style={{
                          maxHeight: '200px',
                          overflowY: 'auto',
                          width: '100%',
                          zIndex: 1000,
                          border: '1px solid #ddd',
                          borderRadius: '4px'
                        }}>
                          {filteredUsers.map(user => (
                            <div 
                              key={user.id}
                              className="mention-item p-2 cursor-pointer"
                              onClick={() => this.handleMentionSelect(user)}
                            >
                              {user.username}
                            </div>
                          ))}
                        </div>
                      )}
                      {newComment.mentionedUsers.length > 0 && (
                        <small className="text-muted">
                          Comentário privado para usuários mencionados
                        </small>
                      )}
                      <div className="d-flex justify-content-end mt-2">
                        <button 
                          className="btn btn-primary btn-sm"
                          onClick={this.handleSubmit}
                        >
                          Publicar
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="comments-section">
                  {this.filterComments(this.sortComments(comments)).map(comment => (
                    <React.Fragment key={comment.id}>
                      {this.montComments(comment, 0, true)}
                      {this.sortComments(comment.resps).map(resp => (
                        <React.Fragment key={resp.id}>
                          {this.montComments(resp, 1)}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              </>
            )}
          </div>
        </SlidingPane>

        {openDialogRemove && (
          <Modal 
            className="modal-dialog-centered modal-danger modal-comment-remove" 
            contentClassName="bg-gradient-danger" 
            isOpen={openDialogRemove}
            zIndex={1052}
          >
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-notification">
                Sua atenção é requerida.
              </h6>
              <button 
                aria-label="Close" 
                className="close" 
                data-dismiss="modal" 
                type="button" 
                onClick={() => this.setState({ openDialogRemove: false })}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="py-3 text-center">
                <i className="fas fa-exclamation-triangle fa-x3" style={{ fontSize: '45px' }}></i>
                <h4 className="heading mt-4">VOCÊ DEVE LER ISTO!</h4>
                <p>Se você prosseguir, este comentário será removido permanentemente.</p>
              </div>
            </div>
            <div className="modal-footer">
              <Button 
                className="btn-white" 
                color="default" 
                type="button" 
                onClick={this.remove}
              >
                Ok, Remova
              </Button>
              <Button 
                className="text-white ml-auto" 
                color="link" 
                data-dismiss="modal" 
                type="button" 
                onClick={() => this.setState({ openDialogRemove: false })}
              >
                Cancelar e fechar
              </Button>
            </div>
          </Modal>
        )}

        {/* Estilos responsivos adicionados via tag style */}
        <style jsx="true">{`
          @media (max-width: 576px) {
            .comment-sliding-pane {
              width: 100% !important;
            }
            .slide-pane__content {
              padding: 0 !important;
            }
            .p-3 {
              padding: 0.5rem !important;
            }
            
            .media-mobile {
              align-items: flex-start !important;
            }
            
            .avatar-container {
              align-self: flex-start;
            }
            
            .user-header {
              width: 100%;
              margin-bottom: 5px;
            }
            
            .comment-actions {
              display: flex;
              flex-wrap: wrap;
              gap: 10px;
              margin-top: 8px;
            }
            
            .comment-actions button {
              font-size: 0.75rem;
              padding: 0 !important;
              margin-right: 0 !important;
              white-space: nowrap;
            }
            
            .btn-group {
              display: flex;
              flex-wrap: wrap;
              gap: 4px;
              width: 100%;
              margin-bottom: 10px !important;
            }
            
            .btn-group .btn {
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding: 4px 8px;
              font-size: 0.7rem !important;
            }
            
            h6 {
              font-size: 0.9rem;
              margin-bottom: 3px !important;
              font-weight: 600;
            }
            
            p {
              font-size: 0.85rem;
              margin-bottom: 0.5rem !important;
            }
            
            small {
              font-size: 0.7rem;
            }

            .btn-outline-secondary {
              width: auto !important;
              min-width: 100px;
              max-width: 140px;
            }
          }

          .comment-sliding-pane {
            z-index: 1051 !important;
          }
          
          .comment-overlay {
            z-index: 1050 !important;
          }
          
          .slide-pane {
            z-index: 1051 !important;
          }

          .comments-locked-box {
            border: 1px dashed #6c757d55;
            padding: 2rem 1rem;
            border-radius: 10px;
            background: linear-gradient(135deg,#f8f9fa,#eef1f5);
            position: relative;
            overflow: hidden;
          }
          .comments-locked-box .icon-wrap i{
            font-size: 56px;
            color: #6c757d;
            text-shadow: 0 2px 4px rgba(0,0,0,0.15);
          }
          .comments-locked-box:before {
            content:"";
            position:absolute;
            inset:0;
            background:
              repeating-linear-gradient(-45deg,rgba(108,117,125,.08) 0 12px,transparent 12px 24px);
            pointer-events:none;
          }
        `}</style>
      </>
    );
  }
}

export default connect(state => ({
  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user,
  unit: state.unit,
  useronline: state.useronline,
  classroom_option: state.classroom_option // <-- adicionar
}))(Comment);
